var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsraelflag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_297_5336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 4.5H0V13.5H27V4.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 1.5H0V4.5H27V1.5Z",
    fill: "#2980B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 0H0V1.5H27V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5H0V13.5H27V16.5Z",
    fill: "#2980B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 18H0V16.5H27V18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2965 8.36299L14.956 7.77253H15.637L15.2965 8.36299ZM14.9547 10.2275L15.2965 9.63828L15.637 10.2275H14.9547H14.9547ZM14.2201 10.2275H12.7803L12.0713 9.00064L12.7803 7.77253H14.2201L14.9279 9.00064L14.2201 10.2275ZM13.4996 11.4747L13.1476 10.8651H13.8516L13.4996 11.4747ZM11.7027 8.36172L11.3622 7.77253H12.0432L11.7027 8.36172ZM11.3622 10.2275L11.7027 9.63828L12.0432 10.2275H11.3622ZM13.4996 6.52529L13.8516 7.13488H13.1476L13.4996 6.52529ZM15.6638 8.99936L16.7401 7.13488H14.5887L13.4996 5.25L12.4118 7.13488H10.2578L10.5333 7.61312L11.3354 9.00064L10.2578 10.8651H12.4118L13.4996 12.75L14.5887 10.8651H16.7414L15.6638 8.99936Z",
    fill: "#2980B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_297_5336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 18,
    rx: 1,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsraelflag);
export default __webpack_public_path__ + "static/media/israelflag.f30fd10a.svg";
export { ForwardRef as ReactComponent };